import type { Category } from '../LaunchStrategy.types'

export const getAbsoluteGuideIndex = (
  categories: Category[],
  activeCategoryIndex: number,
  activeGuideIndex: number,
) =>
  categories
    .slice(0, activeCategoryIndex)
    .reduce((acc, category) => acc + category.guides.length, 0) + activeGuideIndex
